<script>
  import BannerLayout from "./BannerLayout.svelte";
  import TextByCurrency from "./TextByCurrency.svelte";

  import { onMount } from "svelte";

  export let currency;
  export let layoutSettings = {
    enabled: true,
    backgroundColor: "red",
  };
  export let texts = [];
  export let autoUpdateIntervalSeconds = 0;

  let currentIndex = 0;
  let autoUpdateTimerRef;

  const canRotateBanners = texts && texts.length > 1;
  function getTextToDisplay(index) {
    if (!texts || texts.length === 0) {
      return;
    }

    currentIndex = index < 0 ? texts.length - 1 : index % texts.length;
    return texts[currentIndex];
  }

  let textToDisplay = getTextToDisplay(currentIndex);

  function displayNextBanner() {
    currentIndex += 1;
    resetAutoUpdateTimer();
  }

  function displayPrevBanner() {
    currentIndex -= 1;
    resetAutoUpdateTimer();
  }

  function resetAutoUpdateTimer() {
    if (autoUpdateTimerRef) {
      clearInterval(autoUpdateTimerRef);
    }

    if (canRotateBanners && autoUpdateIntervalSeconds > 0) {
      autoUpdateTimerRef = setTimeout(
        () => displayNextBanner(),
        autoUpdateIntervalSeconds * 1000
      );
    }
  }

  onMount(() => {
    resetAutoUpdateTimer();
  });

  $: {
    textToDisplay = { ...getTextToDisplay(currentIndex) };
  }
</script>

{#if texts && texts.length > 0}
  <BannerLayout {...layoutSettings}>
    {#if canRotateBanners}
      <span
        on:click={displayPrevBanner}
        class="tw-px-2 tw-leading-4 tw-cursor-pointer tw-text-sm md:tw-text-lg tw-transition tw-duration-500 tw-ease-in-out tw-transform hover:tw-scale-125"
        >&#8592;</span
      >
    {/if}
    <span class="tw-flex-grow tw-truncate"
      ><TextByCurrency {currency} text={textToDisplay} /></span
    >
    {#if canRotateBanners}
      <span
        on:click={displayNextBanner}
        class="tw-px-2 tw-leading-4 tw-cursor-pointer tw-text-sm md:tw-text-lg tw-transition tw-duration-500 tw-ease-in-out tw-transform hover:tw-scale-125"
        >&#8594;</span
      >
    {/if}
  </BannerLayout>
{/if}
